export const CONTACT = {
  email: "contact@insightproperties.co.uk",
  phone: "Phone number coming soon",
  address: "North West England, United Kingdom",
  hours: "Mon – Fri · 9:00am – 5:30pm GMT",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Landlords", path: "/landlords" },
  { label: "Councils", path: "/local-authorities" },
  { label: "Contact", path: "/contact" },
];

export const IMAGES = {
  heroSkyline:
    "https://images.unsplash.com/photo-1724135869739-6055627ba5df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxNYW5jaGVzdGVyJTIwY2l0eSUyMHNreWxpbmUlMjBldmVuaW5nfGVufDB8fHx8MTc4NzM1MDAxNnww&ixlib=rb-4.1.0&q=85&w=1600",
  salfordQuays:
    "https://images.pexels.com/photos/6199030/pexels-photo-6199030.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  terracedDoors:
    "https://images.unsplash.com/photo-1651964723487-722c8acc07d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBVSyUyMHRlcnJhY2VkJTIwaG91c2VzJTIwc3RyZWV0fGVufDB8fHx8MTc4NzM1MDAxNnww&ixlib=rb-4.1.0&q=85&w=1200",
  terracedMews:
    "https://images.unsplash.com/photo-1510265236892-329bfd7de7a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBVSyUyMHRlcnJhY2VkJTIwaG91c2VzJTIwc3RyZWV0fGVufDB8fHx8MTc4NzM1MDAxNnww&ixlib=rb-4.1.0&q=85&w=1200",
  interiorDark:
    "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxjb3p5JTIwd2FybSUyMG1vZGVybiUyMGxpdmluZyUyMHJvb20lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODczNTAwMTZ8MA&ixlib=rb-4.1.0&q=85&w=1200",
  interiorBright:
    "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxjb3p5JTIwd2FybSUyMG1vZGVybiUyMGxpdmluZyUyMHJvb20lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODczNTAwMTZ8MA&ixlib=rb-4.1.0&q=85&w=1200",
  interiorChaise:
    "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxjb3p5JTIwd2FybSUyMG1vZGVybiUyMGxpdmluZyUyMHJvb20lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODczNTAwMTZ8MA&ixlib=rb-4.1.0&q=85&w=1200",
  handshake:
    "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxoYW5kc2hha2UlMjBidXNpbmVzcyUyMHBhcnRuZXJzaGlwJTIwbWVldGluZ3xlbnwwfHx8fDE3ODczNTAwMTZ8MA&ixlib=rb-4.1.0&q=85&w=1200",
  keys:
    "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGtleXMlMjBuZXclMjBob21lJTIwaGFuZG92ZXJ8ZW58MHx8fHwxNzg3MzUwMDE2fDA&ixlib=rb-4.1.0&q=85&w=1200",
  skylineDay:
    "https://images.unsplash.com/photo-1692968678752-3f24021a188e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxNYW5jaGVzdGVyJTIwY2l0eSUyMHNreWxpbmUlMjBldmVuaW5nfGVufDB8fHx8MTc4NzM1MDAxNnww&ixlib=rb-4.1.0&q=85&w=1200",
};

export const REGIONS = [
  "Manchester", "Liverpool", "Salford", "Bolton", "Preston",
  "Blackburn", "Wigan", "Oldham", "Rochdale", "Warrington", "Stockport", "Bury",
];

export const STATS = [
  { value: "100%", label: "Fully managed" },
  { value: "0", label: "Voids to manage" },
  { value: "24/7", label: "Tenant support" },
  { value: "12+", label: "Towns covered" },
];
